module.exports = __webpack_public_path__ + "static/media/Bariol-Bold.a4e43ac4.woff";